module.exports = __webpack_public_path__ + "img/Group 11.978250cb.svg";